import type { JSX } from 'react'
import type { CardTypeT } from 'blocks/Cards/Card.h'
import type { ILiveEventCard } from './LiveEventCard'

import { TextAligning, TextBox, TextBoxTypes } from 'atoms/TextBox'
import { Colors } from 'atoms/TextBox/TextBox.h'
import { CardType } from 'blocks/Cards/Card.h'
import {
  EventHorizontalNumberSC,
  EventVerticalNumberSC,
  topNumberToPicture,
} from 'blocks/Cards/TopNumbers'
import { FIXED_INDENTS } from 'vars/index'
import { LiveEventCard } from './LiveEventCard'
import {
  TopLiveEventCardSC,
  TopLiveEventPosterAreaSC,
} from './LiveEventCard.styled'

export interface ITopLiveEventCard extends ILiveEventCard {
  topNumber: number
  type: CardTypeT
}

export const TopLiveEventCard = ({
  topNumber,
  type,
  description,
  descriptionFont = TextBoxTypes.FontSmBold,
  rowGap = FIXED_INDENTS.INDENT_30,
  ...rest
}: ITopLiveEventCard): JSX.Element => {
  const TopNumberPicture = topNumberToPicture[topNumber]

  const NumberSC =
    type === CardType.HORIZONTAL_EVENT_TOP_CONTENT
      ? EventHorizontalNumberSC
      : EventVerticalNumberSC

  return (
    <TopLiveEventCardSC type={type} rowGap={rowGap}>
      <TopLiveEventPosterAreaSC type={type}>
        <NumberSC>
          <TopNumberPicture />
        </NumberSC>

        <LiveEventCard {...rest} rowGap={rowGap} />
      </TopLiveEventPosterAreaSC>

      {description && (
        <TextBox
          title={description}
          color={Colors.TEXT_ICON_PRIMARY}
          font={descriptionFont}
          alignment={TextAligning.Left}
          maxLines={2}
        />
      )}
    </TopLiveEventCardSC>
  )
}
